import React from 'react';
import { Link } from 'react-router-dom';
const logoImage = process.env.PUBLIC_URL + '/full-logo-myntar.svg';

const Footer = () => {
  return (
    <footer>
      <div className="footer-content">
        <div className="footer-brand">
          <img 
            src={logoImage} 
            alt="Myntar.io" 
            className="footer-logo"
          />
          <p>
            Plataforma española de avatares inteligentes con IA conversacional 
            avanzada para retail, hostelería y turismo. Tecnología GDPR-nativa europea.
          </p>
          
        </div>
         <div className="footer-column">
          <h4>Contacto</h4>
          <div className="footer-contact">
            <div className="footer-contact-item">📧 contact@myntar.io</div>
            <div className="footer-contact-item">📱 652 49 20 49</div>
            <div className="footer-contact-item">🌐 www.myntar.io</div>
            <div className="footer-contact-item">📍 Córdoba, España</div>
          </div>
        </div>
        <div className="footer-column">
          <h4>Empresa</h4>
          <ul className="footer-links">
            <li><Link to="/nosotros">Sobre Nosotros</Link></li>
            <li><Link to="/nosotros">Equipo</Link></li>
            <li><a href="#contacto">Carreras</a></li>
            <li><a href="#contacto">Blog</a></li>
          </ul>
        </div>
        <div className="footer-column">
          <h4>Soluciones</h4>
          <ul className="footer-links">
            <li><a href="#casos">Retail</a></li>
            <li><a href="#casos">Hostelería</a></li>
            <li><a href="#casos">Educación</a></li>
            <li><a href="#casos">Cultura</a></li>
          </ul>
        </div>
        <div className="footer-column">
          <h4>Legal</h4>
          <ul className="footer-links">
            <li><a href="#">Privacidad</a></li>
            <li><a href="#">Términos</a></li>
            <li><a href="#">Cookies</a></li>
            <li><a href="#">GDPR</a></li>
          </ul>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; 2025 Myntar.io - Todos los derechos reservados</p>
        <p>Hecho con ❤️ en España</p>
      </div>
    </footer>
  );
};

export default Footer;
